import * as actionTypes from 'modules/audits/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = null;

const select = (_, { payload }) => payload?.marker?.id ?? payload?.markerId;
const clear = () => initialState;

export default createReducer(initialState, {
  [actionTypes.POST_MARKER_SUCCESS]: select,
  [actionTypes.SET_SELECTED_MARKER_ID]: select,
  [actionTypes.CLEAR_SELECTED_MARKER_ID]: clear,
  [actionTypes.DELETE_MARKER_SUCCESS]: clear,
});
